export const SET_EMPOWERING_DATA = "SET_EMPOWERING_DATA";

export const setEmpoweringData = (data) => ({
  type: SET_EMPOWERING_DATA,
  payload: data,
});
